function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return [".slds-select", shadowSelector, " {width: 125px;}"].join('');
}
export default [stylesheet];